import { useContext, Fragment } from 'react';

import { ScheduleDemoWizardContext } from '../schedule-demo-wizard';
import { PromoText } from '../types/config';
import { ScheduleDemoMercuryAction } from '../util/send-mercury-event';

type Props = {
  onButtonClick: () => void
  textConfig: PromoText
}

const WebinarPromoStep = (props:Props) => {

  const { emitEvent } = useContext(ScheduleDemoWizardContext);

  const handleButtonClick = () => {
    emitEvent({
      action: ScheduleDemoMercuryAction.WEBINAR_REGISTRATION_ACCESSED_AFTER_CALENDLY_CALENDAR_BOOKING,
    });
    props.onButtonClick();
  };

  return (
    <Fragment>
      <h1 className="schedule-demo-wizard--title">
        {props.textConfig.title}
      </h1>
      <p className="schedule-demo-wizard--copy">
        {props.textConfig.copy}
      </p>
      <button
        className="button is-rounded green-pill-button"
        onClick={ handleButtonClick }
        type="button"
      >
        {props.textConfig.button}
      </button>
    </Fragment>
  );
};

export default WebinarPromoStep;
